export enum TextsActions {
    SEND_TO_SPEAKER = 'envoyer',
    REMOVE_FROM_SPEAKER = 'retirer',
    READONLY = 'readonly'
}